import React, { useState } from "react";

export function MainGameTab({ children, tabStyle, activeClass, inactiveClass, activeTab: externalActiveTab, onTabChange }) {
  // Use state to track which tab is active, with a default of 0 (first tab)
  const [activeTab, setActiveTab] = useState(externalActiveTab || 0);

  const handleTabClick = (index) => {
    setActiveTab(index);
    onTabChange?.(index);
  };

  return (
    <div>
      {/* Tab Headers */}
      <div className={`overflow-x-auto whitespace-nowrap hide-scrollbar ${tabStyle}`}>
        {children.map((child, index) => (
          <button
            key={index}
            className={activeTab === index ? activeClass : inactiveClass}
            onClick={() => handleTabClick(index)}
          >
            {child.props.title}
          </button>
        ))}
      </div>

      {/* Tab Content - only render the active tab's content */}
      <div>
        {children[activeTab]}
      </div>
    </div>
  );
}

export function TabPanel({ children, title, value }) {
  return <div>{children}</div>;
}
